// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tc6Q","newExpiryDate":"styles_newExpiryDate__2i4s_","footer":"styles_footer__2At-y"};